export default "__VITE_ASSET__SyWZ93dD__"